import { VimeoFrame } from "src/utils/fw-extension";
import atrium from "./modals/atrium";
import { ModalWrapper, TimeSwitch } from "src/utils/fw";
import { auditoriumCloseDate } from "../utils";

const memberLinks = [
	{
		height: "13.6%",
		label: "FAQ",
		left: "23.3%",
		top: "76.7%",
		width: "5.4%",
		href: "https://isfcongress.tkeventsregistration.com/2023/faqsvirtual",
		target: "_blank"
	},
	{
		label: "Exploration Zone",
		height: "24.2%",
		href: "/exploration-zone",
		left: "56.2%",
		top: "12%",
		width: "13.6%",
	}
]

const general = [
	{
		label: "Auditorium",
		height: "20.2%",
		href: new Date() < auditoriumCloseDate ? "/auditorium-hall" : undefined,
		left: "57.2%",
		top: "56%",
		width: "12.6%",
		modal: new Date() < auditoriumCloseDate ? undefined : <ModalWrapper wrapperStyle={{background: "rgb(59, 80, 206)", textAlign: "center"}}>
			<h1 style={{color: "white"}}>The Auditorium is now closed.</h1>
			<p style={{color: "white"}}>Please head over to our On-Demand Rooms to view session recordings, and browse through our ISF Exploration Zone and Exhibition Hall until Tuesday 14 November.</p>
		</ModalWrapper>,
		modalOverrides: {
			dismissHTML: "X",
			dismissStyle: {
				color: "white",
				"font-size": "20px"
			}
		}
	},
	{
		label: "Exibition Hall",
		height: "26.2%",
		href: "/exhibition-hall",
		left: "26.2%",
		top: "57%",
		width: "11.6%",
	},
	{
		label: "On Demand",
		href: new Date() > new Date("2023-10-22 08:00:00+0200") ? "/on-demand" : undefined,
		width: "7.6%",
		height: "18.2%",
		left: "28.2%",
		top: "37%",
		modal: new Date() > new Date("2023-10-22 08:00:00+0200") ? undefined : <ModalWrapper wrapperStyle={{background: "rgb(59, 80, 206)"}}>
			<h1 style={{color: "white"}}>On-Demand sessions will be released each day at 08:00 CEST, beginning on Monday 23 October.</h1>
		</ModalWrapper>,
		modalOverrides: {
			dismissHTML: "X",
			dismissStyle: {
				color: "white",
				"font-size": "20px"
			}
		}
	},
	{
		height: "13.4%",
		label: "Welcome",
		left: "71.5%",
		top: "50.4%",
		width: "15.6%",
		modal: <TimeSwitch>
			{[
				{
					starts: new Date("2023-10-22 08:00:00+0200"),
					ends: new Date("2023-10-24 13:59:59+0200"),
					content: <VimeoFrame wrapperStyle={{ backgroundColor: "rgb(59, 80, 206)" }} vidId="874863513?h=bb42626fbe&amp;badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479&autoplay=1" />
				},
				{
					starts: new Date("2023-10-24 14:00:00+0200"),
					ends: new Date("2024-10-24 13:59:59+0200"),
					content: <VimeoFrame wrapperStyle={{ backgroundColor: "rgb(59, 80, 206)" }} vidId="874862975?h=26d05a55b5&amp;badge=0&amp;autopause=0&amp;quality_selector=1&amp;progress_bar=1&amp;player_id=0&amp;app_id=58479&autoplay=1" />
				}
			]}
		</TimeSwitch>,
		modalOverrides: {
			dismissHTML: "X",
			dismissStyle: {
				color: "white",
				"font-size": "20px"
			}
		}
	},
	{
		width: "17.8%",
		height: "20.1%",
		left: "29.6%",
		top: "74.8%",
		label: "Help Desk",
		isExternal: false,	
		onClick: () => {
			openSmartSupp()
		}
	}
]

const background = [
	{
		starts: new Date("2023-10-01 08:00:00+0200"),
		ends: new Date("2023-10-23 07:59:59+0200"),
		content: "https://assets.swoogo.com/uploads/full/2984597-651b0116d990a.png"
	},
	{
		starts: new Date("2023-10-23 08:00:00+0200"),
		ends: new Date("2023-10-24 13:59:59+0200"),
		content: "https://assets.swoogo.com/uploads/full/3063662-652eeda7a01a1.png"
	},
	{
		starts: new Date("2023-10-24 14:00:00+0200"),
		ends: new Date("2024-10-24 07:59:59+0200"),
		content: "https://assets.swoogo.com/uploads/full/3063665-652eedd238511.png"
	}
]

const now = new Date()

export default {
	background: background.find(child => new Date(child.starts) < now && (child.ends === undefined || new Date(child.ends) > now))?.content || background[0].content,
	default: true,
	links: [...general, ...memberLinks],
	extras: atrium,
	name: "atrium",
}
